import React from 'react';
import PropTypes from 'prop-types';
import { SELECT_KIKAN_TABS } from '../../../constants/common/SelectKikanTabs';
import DatePicker from './DatePicker';
import * as commonLogic from '../../../logic/CommonLogic';

/**
 * SelectKikanNew
 */
class SelectKikanNew extends React.Component {
  constructor(props) {
    super(props);
    this.handlePrev = this.handlePrev.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  componentDidMount() {
    if (location.pathname.indexOf('K012') === -1 || this.props.data.kikanUnit !== 'all') {
      const open = document.getElementById('select_kikan_term');
      if (open) {
        open.addEventListener('click', this.handleOpen);
      }
    }
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.data.isOpenCalendar) {
      // 期間が変更された場合は更新する
      if (this.props.data.displayDate !== nextProps.displayDate) {
        return true;
      }
      return false;
    }
    return true;
  }

  componentWillUnmount() {
    if (location.pathname.indexOf('K012') === -1 || this.ptops.data.kikanUnit !== 'all') {
      // K012と全期間指定以外の場合

      const open = document.getElementById('select_kikan_term');
      if (open) {
        open.removeEventListener('click', this.handleOpen);
      }
    }
  }

  /**
   * 絞り込み条件: 後期間(>)の活性判定
   * @returns
   */
  getNextTermData() {
    const termData = this.props.data.termData;
    if (termData == undefined || termData == null || termData.length == 0) return false;

    const currentTerm = this.props.data.term;
    const curretnTermIndex = termData.findIndex(item => item.id == currentTerm);
    let isEnabled = true;
    if (curretnTermIndex == termData.length - 1) {
      isEnabled = false;
    }
    return isEnabled;
  }


  /**
   * 絞り込み条件: 前期間(<)の活性判定
   * @returns
   */
  getPrevTermData() {
    const termData = this.props.data.termData;
    if (termData == undefined || termData == null || termData.length == 0) return false;

    const currentTerm = this.props.data.term;
    const curretnTermIndex = termData.findIndex(item => item.id == currentTerm);
    let isEnabled = true;
    if (curretnTermIndex == 0) {
      isEnabled = false;
    }
    return isEnabled;
  }

  /**
   * 絞り込み条件: 期間種類変更
   * @param {*} tab
   */
  handleTabChange(tab) {
    this.setState({ selectedTab: tab });

    // 選択した期間の日付形式 0: 年 (YYYY), 3: 年/月 (YYYY/MM), 4: 年/月/日 (YYYY/MM/DD),
    let formatType;

    // 選択した期間タブ
    let termUnit;
    // 選択していた期間タブ
    let viewMode;

    switch (tab) {
      case '1日':
        termUnit = 'days';
        viewMode = 'day';
        formatType = 3;
        break;
      case '週間':
        termUnit = 'weeks';
        viewMode = 'day';
        formatType = 2;
        break;
      case '月間':
        termUnit = 'months';
        viewMode = 'month';
        formatType = 1;
        break;
      case '年間':
        termUnit = 'years';
        viewMode = 'year';
        formatType = 0;
        break;
      case '全期間':
        termUnit = 'all';
        viewMode = 'all';
        break;
      default:
        break;
    }

    // 選択した期間
    let selectedTerm = commonLogic.deepCopy(this.props.data.term);
    let targetTermMap = this.props.data.termData.find(map => map.id === selectedTerm);
    let targetTerm = '';

    if (termUnit != 'all') {
      targetTerm = commonLogic.formatDate(selectedTerm, formatType);
      // 選択していた期間の種類
      const currentKikanType = this.props.data.kikanUnit;

      if (currentKikanType == 'weeks' || currentKikanType == 'years') {
        let formatType;
        if (termUnit == 'days') {
          formatType = 3;
        }
        if (termUnit == 'weeks') {
          formatType = 2;
        }
        if (termUnit == 'months') {
          formatType = 1;
        }
        if (termUnit == 'years') {
          formatType = 0;
        }
        targetTerm = commonLogic.formatDate(targetTermMap.to_date, formatType);
      }

      if ((currentKikanType == 'months' && termUnit == 'days')) {
        // 月間→日間の場合、選択した月間の最終期間(to_date)を日形式に変換する
        targetTerm = commonLogic.formatDate(targetTermMap.to_date, 3);
      }

      if ((currentKikanType == 'months' && termUnit == 'weeks')) {
        // 月間→週間の場合、選択した月間の最終期間(to_date)を週間形式に変換する
        targetTerm = commonLogic.formatDate(targetTermMap.to_date, 2);
      }
    }

    // 選択した期間の開始・終了日を取得する
    const termFromToMap = commonLogic.formatTermStartEndById(targetTerm, termUnit);
    const fromDate = termFromToMap.fromDate;
    const toDate = termFromToMap.toDate;

    this.props.comactions.changeKikanUnit(termUnit, viewMode, targetTerm, fromDate, toDate, false);
  }

  /**
   * 絞り込み条件: 前期間(<)のイベント制御
   *
   * @param {*} e
   * @param {*} isEnabled
   * @returns
   */
  handlePrev(e, isEnabled) {
    if (!isEnabled) {
      e.preventDefault();
      return;
    }

    const currentTerm = this.props.data.term;
    const termData = this.props.data.termData;
    const curretnTermIndex = termData.findIndex(item => item.id == currentTerm);
    let prevTermData = [];
    if (curretnTermIndex == -1) {
      // 選択期間が期間データ内に含まれていない場合、期間データの最終日を設定する
      prevTermData = termData[termData.length - 1];
    } else if (curretnTermIndex == 0) {
      prevTermData = termData[0];
    } else {
      prevTermData = termData[curretnTermIndex - 1];
    }

    this.props.comactions.clickKikanCal(prevTermData.id, prevTermData.from_date, prevTermData.to_date);
  }

  /**
   * 絞り込み条件: 後期間(<)のイベント制御
   *
   * @param {*} e
   * @param {*} isEnabled
   * @returns
   */
  handleNext(e, isEnabled) {
    if (!isEnabled) {
      e.preventDefault();
      return;
    }

    const currentTerm = this.props.data.term;
    const termData = this.props.data.termData;
    const curretnTermIndex = termData.findIndex(item => item.id == currentTerm);
    let prevTermData = [];
    if (curretnTermIndex == -1 || curretnTermIndex == termData.length) {
      // 選択期間が期間データ内に含まれていない場合、期間データの最終日を設定する
      prevTermData = termData[termData.length - 1];
    } else {
      prevTermData = termData[curretnTermIndex + 1];
    }

    this.props.comactions.clickKikanCal(prevTermData.id, prevTermData.from_date, prevTermData.to_date);
  }

  handleOpen() {
    if ((!this.props.data.termData) || this.props.data.termData.length === 0) return;
    if (this.props.data.kikanUnit === 'all') return; // 全期間の場合はカレンダーを開かない

    const isNohinCalendar = false;
    let viewMode;
    switch (this.props.data.kikanUnit) {
      case 'days':
      case 'weeks':
        viewMode = 'day';
        break;
      case 'months':
        viewMode = 'month';
        break;
      case 'years':
        viewMode = 'year';
        break;
      default:
        break;
    }
    const isFromDatePicker = false;
    let currentDate;
    if (this.props.data.kikanUnit == 'weeks') {
      let termStart;
      // 週間の場合日付形式を変換する(YYYY-W99 から YYYY-MM-DD)
      const termFromToMap = commonLogic.getWeekStartAndEnd(this.props.data.term, 7, 3);
      const termDataIndex = this.props.data.termData.findIndex(item => item.id == this.props.data.term);
      if (termDataIndex == 0) {
        // 過去日の場合
        termStart = this.props.data.termData[0].from_date;
      } else {
        // 直近日・中日の場合
        termStart = termFromToMap[0];
      }
      currentDate = new Date(termStart);
    } else {
      currentDate = new Date(this.props.data.term);
    }

    this.props.comactions.openDatePicker(currentDate, isNohinCalendar, viewMode, isFromDatePicker);

  }

  render() {
    // 画面表示パターンの判定
    let dispKey = location.pathname;
    if (dispKey.indexOf('K012') != -1) {
      return (
        <div className="filter_item">
          <div className="ctrl_form_title controlForm__title--state_disable controlForm__text--state_disable">
            <p>期間</p>
          </div>
          <div>
            <p className="sel_term controlForm__text--state_disable">&nbsp;全期間</p>
          </div>
        </div>
      );
    }

    // 期間タブのリスト設定
    const currentPath = window.location.pathname.split('/');
    const screenKey = currentPath[1];
    const tabs = SELECT_KIKAN_TABS[screenKey];

    // 指定期間種類
    const termUnit = this.props.data.kikanUnit;
    let viewData;
    if (termUnit === 'days' || termUnit === 'weeks') {
      viewData = '-- / -- / --';
    } else if (termUnit === 'months') {
      viewData = '-- / --';
    } else {
      viewData = '--';
    }

    let termKey = '';

    if (this.props.data.termData != null) {

      let defaultValue = this.props.data.term;

      // 期間のURLパラメータがある場合
      if (defaultValue != null) {
        let weekStartEndList = [];
        // 表示する期間値（開始）
        let viewDataFrom;
        // 表示する期間値（終了）
        let viewDataTo;

        switch (termUnit) {
          case 'days':
            viewData = defaultValue.replace(/-/g, ' / ');
            break;
          case 'weeks':
            weekStartEndList = commonLogic.getWeekStartAndEnd(this.props.data.term, 7, 3);
            viewDataFrom = weekStartEndList[0];
            viewDataTo = weekStartEndList[weekStartEndList.length - 1];

            if (!this.getNextTermData()) {
              // 直近日の期間を選択している場合はtermDataの直近日を設定する
              viewDataTo = commonLogic.toLocaleString(new Date(this.props.data.termData[this.props.data.termData.length - 1].to_date)).replaceAll(/\//g, '-');
            }
            if (!this.getPrevTermData()) {
              // 最古日の期間を選択している場合はtermDataの最古日を設定する
              viewDataFrom = commonLogic.toLocaleString(new Date(this.props.data.termData[0].from_date)).replaceAll(/\//g, '-');
            }

            viewData = `${viewDataFrom.replaceAll(/-/g, ' / ')}　～　${viewDataTo.replaceAll(/-/g, ' / ')}`;
            break;
          case 'months':
            viewData = defaultValue.replace(/-/g, ' / ');
            break;
          default:
            viewData = defaultValue;
            break;
        }

        termKey = defaultValue;
      }
    }

    let targetTab;
    if (screenKey != 'K012') {
      switch (termUnit) {
        case 'days':
          targetTab = '1日';
          break;
        case 'weeks':
          targetTab = '週間';
          break;
        case 'months':
          targetTab = '月間';
          break;
        case 'years':
          targetTab = '年間';
          break;
        case 'all':
          targetTab = '全期間';
          break;
        default:
          break;
      }
    }

    // 期間次前のラベル設定
    let prevLabel;
    let nextLabel;

    switch (targetTab) {
      case '1日':
        prevLabel = '前日';
        nextLabel = '翌日';
        break;
      case '週間':
        prevLabel = '前週';
        nextLabel = '翌週';
        break;
      case '月間':
        prevLabel = '前月';
        nextLabel = '翌月';
        break;
      case '年間':
        prevLabel = '前年';
        nextLabel = '翌年';
        break;
      default:
        prevLabel = '';
        nextLabel = '';
        break;
    }

    // 前後の期間のデータ有無によって表示を制御する
    let isPrevEnabled = true;
    let isNextEnabled = true;
    let prevDisabledClassName = '';
    let nextDisabledClassName = '';
    let termData = this.props.data.termData;
    let disabledIfAll = '';

    if (!this.props.data.term || !termData) {
      prevDisabledClassName = 'disabled';
      isPrevEnabled = false;
      nextDisabledClassName = 'disabled';
      isPrevEnabled = false;
    } else {
      // 前期間のデータを確認
      isPrevEnabled = this.getPrevTermData();
      prevDisabledClassName = isPrevEnabled ? '' : 'disabled';
      // 翌期間のデータを確認
      isNextEnabled = this.getNextTermData();
      nextDisabledClassName = isNextEnabled ? '' : 'disabled';
    }

    if (termUnit == 'all') {
      // 全期間の場合、各UIを非活性とする
      prevDisabledClassName = 'disabled';
      isPrevEnabled = false;
      nextDisabledClassName = 'disabled';
      isNextEnabled = false;
      viewData = '全期間';
      disabledIfAll = 'disabled';
    }

    return (
      <div className="filter_item">
        <div className="ctrl_form_title controlForm__title--state_enable controlForm__text--state_enable">
          <p>期間</p>
          <p id="sel_term_key" hidden>{termKey}</p>
          <p id="sel_term_key_when_open" hidden>{termKey}</p>
          <p id="termStartWhenOpen" hidden />
          <p id="termEndWhenOpen" hidden />
          <p id="kikanCalendarStatus" hidden />
          <p id="kikanUnitActive" hidden>{termUnit}</p>
        </div>
        <div className="select_kikan_tabs">
          <div className="tab-buttons">
            {tabs.map(tab => (
              <button
                key={tab}
                className={targetTab === tab ? 'active' : ''}
                onClick={() => this.handleTabChange(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
          {/* <div className="select_kikan_tab_controls">
            <div id="kikanPrev" className="kikan_control_button" onClick={(e) => { this.handlePrev(e, isPrevEnabled); }}>
              <span className={`arrow_left_calendar  ${prevDisabledClassName}`} />
              <p className={prevDisabledClassName}>{prevLabel}</p>
            </div>
            <span className="spacer" />
            <div id="kikanNext" className="kikan_control_button"  onClick={(e) => { this.handleNext(e, isNextEnabled); }}>
              <p className={nextDisabledClassName}>{nextLabel}</p>
              <span className={`arrow_right_calendar ${nextDisabledClassName}`} />
            </div>
          </div> */}
        </div>
        <div id="select_kikan_term" className="select_kikan_term">
          <div id="sort_date" className="controlForm__Kikan--state_enable" data-title="calender01">
            <p className={`sel_term ${disabledIfAll}`}>{viewData}</p>
            <a className="btn sort_reload" href="#">
              <span className={`date_range ${disabledIfAll}`} />
            </a>
          </div>
        </div>
        {this.props.data.isOpenCalendar && !this.props.data.isNohinCalendar && (
          <DatePicker
            comactions={this.props.comactions}
            data={this.props.data}
          />
        )}
      </div>
    );
  }
}

SelectKikanNew.propTypes = {
  comactions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default SelectKikanNew;
